import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectValue, setValue } from "../../store/timezoneSlice";

// =============================================================================
// WithTimezone Component
// Wrapper that injects Redux timezone props into children
// =============================================================================

interface WithTimezoneProps {
  children: React.ReactElement<{
    timezoneValue?: string;
    onTimezoneChange?: (tz: string) => void;
  }>;
}

export const WithTimezone: React.FC<WithTimezoneProps> = ({ children }) => {
  const dispatch = useDispatch();
  const timezoneValue = useSelector(selectValue);

  const handleTimezoneChange = React.useCallback(
    (newTimezone: string) => {
      dispatch(setValue(newTimezone));
    },
    [dispatch]
  );

  return React.cloneElement(children, {
    timezoneValue,
    onTimezoneChange: handleTimezoneChange,
  });
};
